import Profiles from "./Profiles";
import UploadFiles from "./UploadFiles";
import LoginSignup from "./LoginSignup";

const repositories = {
    profiles: Profiles,
    upload: UploadFiles,
    login: LoginSignup
};
  
export const RepositoryFactory = {
    get: name => repositories[name]
};
  